// Main client export
export { WhatsAppClient } from './client/WhatsAppClient';
export { WhatsAppClient as default } from './client/WhatsAppClient';

// Resource exports (for advanced usage)
export { Sessions } from './resources/Sessions';
export { Messages } from './resources/Messages';
export { Chats } from './resources/Chats';
export { Contacts } from './resources/Contacts';
export { Groups } from './resources/Groups';
export { Status } from './resources/Status';
export { Webhooks } from './resources/Webhooks';
export { Admin } from './resources/Admin';
export { Business } from './resources/Business';

// Enhanced SDK Features
export { BotFramework, middleware } from './bot';
export { MessageQueue, TokenBucketRateLimiter } from './queue';
export { DatabaseAdapter, MongoDBAdapter, WhatsAppFieldMappings, CommonTransformers } from './adapters';
export { PollingService } from './polling';
export { MigrationHelper, MigrationConfigs } from './migration';
export { SessionManager, InMemorySessionStore, MongoSessionStore } from './session';
export { MetricsCollector, ConsoleExporter, PrometheusExporter, FileExporter, WhatsAppMetrics } from './metrics';

// Type exports
export * from './types';
export * from './bot';
export * from './queue';
export * from './adapters';
export * from './polling';
export * from './migration';
export * from './session';
export * from './metrics';

// Version
export const VERSION = '2.0.0';